<template>
  <div class="rootLayout">
    <el-row style="margin:5px 0;">
      <el-col :span="2" style="text-align:left;">
        <el-button @click="uploadAffix" icon="el-icon-upload" size="medium" type="primary">上传</el-button>
      </el-col>
      <el-col :span="22">

      </el-col>
    </el-row>
    <el-table :data="affixDataList" width="99%" border>
      <el-table-column label="序号">
        <template slot-scope="scope">
          {{scope.$index+1}}
        </template>
      </el-table-column>
      <el-table-column label="名称" prop="name">

      </el-table-column>
      <el-table-column label="附件类型" prop="fileType">

      </el-table-column>
      <el-table-column label="大小" prop="size">

      </el-table-column>
      <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="dowload(scope.row)">下载</el-button>
            <el-button  size="mini" type="primary" @click="preview(scope.row)">查看</el-button>
            <el-button  size="mini" type="primary" @click="remove(scope.row)">删除</el-button>
            <!--<el-button  size="mini" type="primary" @click="modify(scope.row)">编辑</el-button>-->
          </template>
      </el-table-column>
    </el-table>
    <el-dialog title="附件预览" :visible.sync="previewFileShow" width="1024px" height="640px" :append-to-body='true' top="0"
    :close-on-press-escape='false'
    :close-on-click-modal='false'
     style="padding:5px 5px;">
      <PreviewFile :file="previewFile" v-if="previewFileShow"></PreviewFile>
    </el-dialog>
    <el-dialog title="上传文件" :visible.sync="upload.dialogVisible" :append-to-body="true" :close-on-click-modal="false" v-loading="upload.uploading">
       <el-form :model="uploadInfo">
         <el-form-item label="文件名称:">
          <el-input v-model="uploadInfo.name"></el-input>
         </el-form-item>
         <el-form-item label="文件说明:">
          <el-input v-model="uploadInfo.description" :rows="2"></el-input>
         </el-form-item>
         <el-form-item label="附件类型:">
          <el-select v-model="uploadInfo.type" placeholder="请选择附件类型">
            <el-option v-for="(type,index) in affixTypes" :key="index" :value="type">{{ type}}</el-option>
          </el-select>
         </el-form-item>
       </el-form>
        <el-upload :auto-upload="false" ref="upload" :on-change="onUploadFileChange" action="" :file-list="upload.fileList">
        <el-button type="success">选择文件<i class="el-icon-plus"></i></el-button>
      </el-upload>
      <el-row>
        <el-col :span="8">
            &nbsp;
        </el-col>
        <el-col :span="8" style="text-align:center;">
          <el-button type="primary" @click="save">保存</el-button>
          <el-button type="dangger" @click="cancelUpload">取消</el-button>
        </el-col>
        <el-col :span="8">
          &nbsp;
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getRequest, postRequest, uploadFileRequest } from '../../../utils/api'
import PreviewFile from './PreviewFile.vue'
export default{
  name: 'AffixManage',
  components: {
    PreviewFile
  },
  props: {
    projectId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      affixDataList: [
      ],
      previewFile: {}, // 传递的参数
      previewFileShow: false, // 默认预览框是关闭状态,
      baseUrl: '',
      upload: {
        dialogVisible: false,
        fileList: [],
        uploading: false
      },
      uploadInfo: {
        name: '',
        refId: this.projectId,
        description: '',
        type: null,
        size: 0,
        url: ''
      },
      affixTypes: []
    }
  },
  mounted: function () {
    this.baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8082/api' : `http://${window.location.host}/api`
    this.getAffixTypes()
    this.fetchAffixData()
  },
  watch:
  {
    projectId: (oldValue, newValue) => {
      this.fetchAffixData()
    }
  },
  methods: {
    dowload (affix) {
      let downloadLink = document.createElement('a')
      downloadLink.setAttribute('href', `${this.baseUrl}/${affix.filePath}`)
      downloadLink.setAttribute('target', '_blank')
      downloadLink.click()
    },
    remove (affix) {
      postRequest('project/deleteAffix', {id: affix.id}).then(resp => {
        if (resp.data.status) {
          this.$message.success('删除成功')
          this.fetchAffixData()
        } else {
          this.$message.error('删除失败请重试！')
        }
      }).catch(e => {
        this.$message.error('删除失败请重试！')
      })
    },
    modify (affix) {

    },
    getAffixTypes () {
      getRequest('affix/project-affix-types').then(resp => {
        this.affixTypes = resp.data.data
      })
    },
    fetchAffixData () {
      postRequest('project/listAffix', {projectId: this.projectId}).then(resp => {
        this.affixDataList = resp.data.data
      })
    },
    save () {
      let indexOfDot = this.uploadInfo.url.lastIndexOf('.')
      this.uploading = true
      postRequest('project/addAffix', {
        filePath: this.uploadInfo.url,
        name: this.uploadInfo.name,
        size: this.uploadInfo.size,
        descripiton: this.uploadInfo.description,
        refId: this.projectId,
        fileType: this.uploadInfo.type,
        extention: this.uploadInfo.url.substring(indexOfDot, this.uploadInfo.url.length)
      }).then(resp => {
        this.uploading = false
        if (resp.data.status) {
          this.$message.success(resp.data.msg)
          this.fetchAffixData()
          this.upload.dialogVisible = false
        } else {
          this.$message.error(resp.data.msg)
        }
      }).catch(e => {
        this.$message.error('保存失败请重试')
        this.uploading = false
      })
    },
    cancelUpload () {
      this.upload.dialogVisible = false
    },
    uploadAffix () {
      this.upload.dialogVisible = true
    },
    handleClose () {
      this.previewFileShow = true
    },
    preview (row) {
      this.previewFileShow = true
      this.previewFile.fileName = row.filePath
      this.previewFile.downloadUrl = this.baseUrl + '' + row.filePath
    },
    onUploadFileChange (file, fileList) {
      let formData = new FormData()
      formData.append('file', file.raw)
      this.uploading = true
      uploadFileRequest('/uploadFile', formData).then(resp => {
        this.upload.fileList = fileList.splice(fileList.length - 1, 1)
        this.uploadInfo.name = file.name
        this.uploadInfo.description = file.name
        this.uploadInfo.size = file.size
        this.uploadInfo.url = resp.data.returnUrl
        this.upload.fileList[0].percentage = 100
        this.upload.fileList[0].status = 'OK'
        this.uploading = false
      }).catch(e => {
        this.uploading = false
      })
    }
  }
}
</script>

<style scoped>
.rootLayout{
  width:100%;
  height: 100%;
  padding:5px;
  margin:0;
}
</style>



// WEBPACK FOOTER //
// src/Views/Project/components/AffixManage.vue